module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-angry.22e8cb91.png";